import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React from 'react';
import {convertTimeAgo} from '../../../../../utilities/helper/timeConventor';

interface ReplyProductProps {
  is_author: boolean;

  chat: IMessagesChatsResults;
}
const ReplyProduct = ({chat, is_author}: ReplyProductProps) => {
  return (
    <div
      className={classNames('flex items-center w-full px-4', {
        'justify-start': is_author,
        'justify-end': !is_author,
      })}
    >
      {chat.product_info.product_type !== 'REQUIREMENT' ? (
        <div
          className={classNames(
            'flex gap-1 w-[90%] h-[128px] items-center p-2 rounded-lg  shadow-[0_4px_5px_rgba(171,190,209,0.3)]',
            {
              'bg-farm-shop-200': is_author,
              'bg-white': !is_author,
            },
          )}
        >
          <div className="min-w-[112px] min-h-[112px] h-[112px] w-[112px]">
            <img
              className="rounded-lg min-w-[112px] min-h-[112px] h-[112px] w-[112px]"
              alt={chat.product_info.title}
              src={
                chat?.product_info?.main_image?.image_128 ||
                'https://s3.ir-thr-at1.arvanstorage.ir/shop-advertisement/empty_card_image.svg'
              }
            />
          </div>
          <div className="w-full flex flex-col h-full justify-between ">
            <div className="w-full flex flex-col">
              <p className="m-0 p-0 text-gray-950 text-md font-Regular line-clamp-1">
                {chat.product_info.title}
              </p>
              <div className="flex items-center gap-2 text-gray-700">
                <SpanIcon className="icon-nameLocation" />
                <span className="text-sm ">
                  {chat.product_info?.state?.name} .
                  {chat.product_info?.city?.name}
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700">
                {convertTimeAgo(chat.product_info.published_date)}
              </div>
            </div>
            <div className=" text-md font-Regular  w-full flex  justify-end">
              {chat.product_info.ad_price} تومان
            </div>
          </div>
        </div>
      ) : (
        <div className="w-[90%] py-2 rounded-lg  shadow-[0_4px_5px_rgba(171,190,209,0.3)] bg-gray-100 flex flex-col px-2 justify-center">
          <p className="text-gray-800 text-md  font-Regular">
            {chat?.product_info.title}
          </p>
          <div className="w-flex flex  justify-between">
            <div className="flex items-center">
              <SpanIcon className="icon-nameLocation text-gray-700" />
              <span className="text-sm text-gray-700 font-Regular">
                {chat.product_info?.state?.name} .
                {chat.product_info?.city?.name}
              </span>
            </div>
            <span className="text-gray-700 text-xs font-Regular">
              {convertTimeAgo(chat.product_info.published_date)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReplyProduct;
